import React from "react";
import { useSelector } from "react-redux";

function Header() { 
  const { activeObjFarmers } = useSelector((state) => ({
    activeObjFarmers: state.obj.activeObj["farmers"]
  }));
  
  return (
    <div className="white_card mt-[2.06rem]">
      <div className="form-add-h !text-[#0092CC] ">
        {activeObjFarmers?.fullNames}
      </div>
      <div className="flex items-center gap-x-[.62rem] dash-card-h1 mt-[.63rem]">
        <span>{activeObjFarmers?.usrNationalId}</span>
        <span>•</span>
        <span>{activeObjFarmers?.usrCountyName}</span>
      </div>
    </div>
  );
}

export default Header;
